module.exports = __webpack_public_path__ + "static/media/our_clients_testimony1_responsive.50243ad5.png";